import {
    all,
    takeLatest,
    apply,
    put,
} from 'redux-saga/effects';

import {
    ATTEMPT_FETCH_SUBSCRIPTION_STATUS,
    FETCH_SUBSCRIPTION_STATUS_SUCCEEDED,
    FETCH_SUBSCRIPTION_STATUS_FAILED,
} from 'shared_redux/actions';
import API from 'services/subscriptions';
import { handleError } from 'services/alerts';

export default function* SubscriptionsSaga() {
    yield all([
        takeLatest(ATTEMPT_FETCH_SUBSCRIPTION_STATUS, fetchSubscriptionStatus),
    ]);
};

function *fetchSubscriptionStatus(action) {
    try {
        const subscriptionData = yield apply(API, API.getSubscriptionStatus, [action.organizationId]);
        yield put({
            type: FETCH_SUBSCRIPTION_STATUS_SUCCEEDED,
            subscriptionData: {
                organizationId: action.organizationId,
                ...subscriptionData
            },
        });
    } catch(error) {
        yield put({
            type: FETCH_SUBSCRIPTION_STATUS_FAILED,
            error: error.message || 'Failed to fetch subscription status'
        });
        yield handleError(error, 'Error: Unable to fetch subscription status');
    }
}
